import { IMainLayoutProps } from '@foxtaibox/foxtailbox-frontend-core';
import withErrorBoundary from 'hocs/withErrorBoundary';
import HeaderlessMainLayout from 'layouts/MainLayout/components/HeaderlessMainLayout';

const ExaminationRegisterLayout = (props: IMainLayoutProps) => {
  const { children, ...rest } = props;

  return (
    <HeaderlessMainLayout
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    >
      {children}
    </HeaderlessMainLayout>
  );
};

export default withErrorBoundary(ExaminationRegisterLayout);
